// extracted by mini-css-extract-plugin
export default {"BoutonEnTete":"EnTete_BoutonEnTete__+2Rng"};